import { config } from '../../config';

export const SiteTitle = config.COMPANY_NAME + ' ECサイト';
